<template>
  <div class="sub-header">
    <div class="sub-header-left">
      <template v-if="showAdminSiteFilters">
        <div class="filter-choice">
          <label class="filter-label">발주처</label>

          <select
            class="filter-select"
            :value="selectedClientId || ''"
            @change="onClientChange"
          >
            <option value="">전체 발주처</option>

            <option
              v-for="client in clientOptions"
              :key="client.id"
              :value="client.id"
            >
              {{ client.name }}
            </option>
          </select>
        </div>

        <div class="filter-choice">
          <label class="filter-label">대리점</label>

          <select
            class="filter-select"
            :value="selectedAgencyId || ''"
            @change="onAgencyChange"
          >
            <option value="">전체 대리점</option>

            <option
              v-for="agency in agencyOptions"
              :key="agency.id"
              :value="agency.id"
            >
              {{ agency.name }}
            </option>
          </select>
        </div>
      </template>

      <AreaChoice
        :areas="areas"
        :selectedArea="selectedArea"
        labelText="현장 선택"
        placeholderText="현장을 선택하세요"
        @change="$emit('area-change', $event)"
      />
    </div>

    <div class="actions">
      <template v-if="config.type === 'main'">
        <button
          v-for="(action, index) in config.actions"
          :key="index"
          @click="$emit('action', action)"
        >
          {{ action }}
        </button>
      </template>

      <template v-else-if="config.type === 'sensor'">
        <div class="date-range">
          <div class="date-input">
            <i class="fa-regular fa-calendar icon"></i>
            <flat-pickr
              v-model="fromDate"
              :config="dateConfig"
              placeholder="from"
            />
          </div>

          <span class="tilde">~</span>

          <div class="date-input">
            <i class="fa-regular fa-calendar icon"></i>
            <flat-pickr
              v-model="toDate"
              :config="dateConfig"
              placeholder="to"
            />
          </div>
        </div>

        <button @click="onConfirm">기간변경</button>
        <button @click="$emit('action', 'CSV 출력')">CSV 출력</button>
        <button @click="$emit('action', '보고서 출력')">보고서 출력</button>
      </template>
    </div>
  </div>
</template>

<script>
import AreaChoice from '@/components/common/AreaChoice.vue'
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Korean } from 'flatpickr/dist/l10n/ko.js'

export default {
  name: 'SubHeaderBar',

  components: {
    AreaChoice,
    FlatPickr
  },

  props: {
    areas: Array,
    selectedArea: Object,
    config: {
      type: Object,
      default: () => ({})
    },

    showAdminSiteFilters: {
      type: Boolean,
      default: false
    },
    clientOptions: {
      type: Array,
      default: () => []
    },
    agencyOptions: {
      type: Array,
      default: () => []
    },
    selectedClientId: {
      type: [Number, String, null],
      default: null
    },
    selectedAgencyId: {
      type: [Number, String, null],
      default: null
    }
  },

  emits: [
    'area-change',
    'client-change',
    'agency-change',
    'action',
    'date-change'
  ],

  data() {
    return {
      fromDate: null,
      toDate: null,

      // Flatpickr 설정
      dateConfig: {
        enableTime: true,
        time_24hr: true,
        dateFormat: 'Y-m-d H:i',
        minuteIncrement: 1,

        // 달력 한글화
        locale: Korean,
      }
    }
  },

  mounted() {
    const now = new Date()

    // to : 현재 시각
    this.toDate = new Date(now)

    // from : 오늘 기준 7일 전
    const oneWeeksAgo = new Date(now)
    oneWeeksAgo.setDate(oneWeeksAgo.getDate() - 7)
    this.fromDate = oneWeeksAgo
  },

  methods: {
    onConfirm() {


      console.log('selectedArea:', this.selectedArea)
      console.log('from:', this.fromDate)
      console.log('to:', this.toDate)

      this.$emit('date-change', {
        from: this.fromDate,
        to: this.toDate
      })

      // 기간변경 버튼 클릭 액션
      this.$emit('action', '기간변경')
    },

    onClientChange(event) {
      const value = event.target.value
      this.$emit('client-change', value ? Number(value) : null)
    },

    onAgencyChange(event) {
      const value = event.target.value
      this.$emit('agency-change', value ? Number(value) : null)
    },
  }
}
</script>

<style scoped>
.sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 24px 12px;
  box-sizing: border-box;
}

.sub-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* 필터 카드 느낌 */
.filter-choice {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 10px 14px;
  background: rgba(255,255,255,0.45);
  border: 1px solid rgba(0,0,0,0.04);
  border-radius: 14px;

  backdrop-filter: blur(6px);
  transition: all 0.2s ease;
}

.filter-choice:hover {
  background: rgba(255,255,255,0.75);
  border-color: rgba(59,130,246,0.15);
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
}

.filter-label {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--color-text-main);
  white-space: nowrap;

  min-width: 52px;
}

/* select 고급스럽게 */
.filter-select {
  width: 180px;
  height: 42px;
  padding: 0 42px 0 14px;

  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text-main);

  background: linear-gradient(
    to bottom,
    #ffffff,
    #f8fafc
  );

  border: 1px solid #d7dde5;
  border-radius: 12px;

  appearance: none;
  cursor: pointer;

  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.12s ease;
}

.filter-select:hover {
  border-color: #c4d0df;
}

.filter-select:focus {
  outline: none;
  background: #fff;
  border-color: var(--color-primary);

  box-shadow:
    0 0 0 3px rgba(59,130,246,0.12);
}

/* select 화살표 */
.filter-choice {
  position: relative;
}

.filter-choice::after {
  content: '';
  position: absolute;
  right: 22px;
  top: 50%;
  transform: translateY(-20%);

  width: 0;
  height: 0;

  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #94a3b8;

  pointer-events: none;
}

.actions {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-input {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 10px;
  background-color: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: 8px;
}

.date-input .icon {
  font-size: 0.8rem;
  color: var(--color-text-sub);
}

.date-input .flatpickr-input {
  width: 150px;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text-main);
  text-align: center;
  font-size: 0.8rem;
}

.date-input:focus-within {
  border-color: var(--color-primary-border);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--color-primary) 35%, transparent);
}

.date-input .flatpickr-input::placeholder {
  color: var(--color-text-sub);
}

.tilde {
  font-weight: 600;
  color: var(--color-text-sub);
}

.actions button {
  height: 36px;
  padding: 0 14px;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--color-text-main);
  background-color: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  cursor: pointer;
}

.actions button:hover {
  border-color: var(--color-primary-border);
  background: var(--color-bg-hover);
}
</style>